<template>
  <div class="page">
    <div class="page-header">
      <div class="title">
        <v-btn icon dark @click="goBack"
          ><v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
        {{ tagEvent }}
      </div>
      <div class="subtitle">{{ logSessionId }}</div>
    </div>
    <div class="page-content">
      <v-card class="card-content" dark>
        <v-row>
          <v-col cols="4" class="log-field">
            <div class="log-label">Fornecedor</div>
            <div class="log-value">{{ idfornecedor }}</div>
          </v-col>
          <v-col cols="4" class="log-field">
            <div class="log-label">Usuário</div>
            <div class="log-value">{{ idusuario }}</div>
          </v-col>
          <v-col cols="4" class="log-field">
            <div class="log-label">Requisição</div>
            <div class="log-value">{{ request }}</div>
          </v-col>
          <v-col cols="4" class="log-field">
            <div class="log-label">Ação</div>
            <div class="log-value">{{ action }}</div>
          </v-col>
          <v-col cols="4" class="log-field">
            <div class="log-label">Data da alteração</div>
            <div class="log-value">{{ date }}</div>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        class="card-content card-log"
        dark
        v-for="(entidade, index) in entidades"
        :key="entidade + '-' + index"
      >
        <div class="log-entidade-pretitle">Anterações em</div>
        <div class="entidade-title">{{ entidade.entidade }}</div>
        <v-row>
          <v-col
            cols="4"
            class="log-field "
            v-for="tag in entidade.tags"
            :key="tag.tag"
          >
            <div class="log-label">{{ tag.tag }}</div>
            <div class="log-value">{{ tag.value }}</div>
          </v-col>
          <v-col cols="12">
            <Logdiff
              :jsonbefore="entidade.before"
              :jsonafter="entidade.after"
            />
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import { LogAudit } from '../service/Api'
import Logdiff from '../components/LogDiff'
import * as _ from 'lodash'
import moment from 'moment'

export default {
  name: 'LogDetails',
  data: () => ({
    log: {},
  }),
  created() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    const logId = this.$route.params.id
    this.loadData(logId)
  },
  components: { Logdiff },
  computed: {
    tagEvent() {
      return _.get(this.log, 'tagEvent', '')
    },
    logSessionId() {
      return _.get(this.log, 'logSessionId', '')
    },
    idfornecedor() {
      return _.get(this.log, 'idfornecedor', '')
    },
    idusuario() {
      return _.get(this.log, 'idusuario', '')
    },
    request() {
      return `${_.get(this.log, 'requestMethod', '')}: ${_.get(
        this.log,
        'requestUrl',
        ''
      )}`
    },
    action() {
      return _.get(this.log, 'tagEventDescription', '')
    },
    date() {
      const data = _.get(this.log, 'data', '')
      return moment(data).format('DD/MM/YYYY HH:mm')
    },
    entidades() {
      return _.get(this.log, 'entidades', [])
    },
  },
  methods: {
    loadData(id) {
      LogAudit.getById(id)
        .then(data => {
          this.log = _.get(data, 'data')
        })
        .catch(err => {
          console.lof(err)
        })
    },
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss">
.card-log {
  margin-top: 10px;
  text-align: left;
  .log-entidade-pretitle {
    font-size: 13px;
    font-weight: 900;
  }
  .entidade-title {
    font-size: 17px;
  }
}
.log-field {
  text-align: left;
  .log-label {
    font-size: 900;
  }
  .log-value {
    font-size: 13px;
  }
}
</style>
